import { type User } from '@auth0/auth0-react';
import { isUsingDarkTheme } from '@strata/react-header';

import { type FmhToken } from 'api/authAPI';
import { type SupplierDetails } from 'store/api/referenceApi';

export const initializePendo = (fmhToken: FmhToken, user: User | undefined) => {
    if (user) {
        pendo.initialize({
            apiKey: process.env.REACT_APP_PENDO_API_KEY,
            visitor: {
                id: user.email!,
                role: fmhToken.role_name,
                email: user.email!,
                name: user.name!,
                dark_mode: isUsingDarkTheme(),
                analytics_access: fmhToken.analytics_access,
            },
            account: { id: fmhToken.npi, org: fmhToken.npi },
        });
    }
};

export const updatePendoUserMetadata = (supplierDetails: SupplierDetails) => {
    pendo.updateOptions({
        account: { name: supplierDetails.name, org_size: supplierDetails.orgSize! },
    });
};
